import type { Editor, JSONContent } from "@tiptap/react";

/**
 * Converts a string content to a JSON content for Tiptap.
 *
 * NOTE: Only supports paragraph nodes for now.
 *
 * @param content - The string content to convert.
 * @returns The JSON content for Tiptap.
 */
export function stringContentToJSON(content: string): JSONContent {
    return {
        type: "doc",
        content: content.split("\n").map((line) => {
            if (line === "") {
                return {
                    type: "paragraph",
                };
            }

            return {
                type: "paragraph",
                content: [{ type: "text", text: line }],
            };
        }),
    };
}

export function getTextContentWithoutNewlines(editor: Editor): string {
    return editor
        .getText({
            blockSeparator: "\n",
        })
        .trim();
}
